import type { MarisaAuto } from '~/@types/MarisaAuto/form';
import type { InsuranceQuoteRequestDTO } from '~/dto/Insurance/insuranceQuoteRequestDTO';
import { formatBrDate, parseDate } from '~/utils/date';
import { getRawCellphone, getRawDocument, getRawZipcode } from '~/utils/string';

const MARTIAL_STATUS_CODES = {
  single: '1',
  married: '2',
  widower: '3',
  divorced: '4',
};

export const insuranceQuoteRequestMapper = (
  form: MarisaAuto.Form,
  vendaLoginCpf: string
): InsuranceQuoteRequestDTO => {
  const formattedCellphone = getRawCellphone(form.phoneNumber);
  const formattedZipcode = getRawZipcode(form.address.zipcode);
  const [fipeCode, fipeDigit] = form.fipeDetails.fipeCode.split('-');
  const formatStorageVehicle = Object.entries(form.storageVehicle).map(
    ([id, data]) => ({
      id: Number(id),
      resposta: {
        id: data.selectedAnswer || 0,
      },
    })
  );

  const martialStatusId =
    MARTIAL_STATUS_CODES[
      form.personalInformation
        .maritalStatus as keyof typeof MARTIAL_STATUS_CODES
    ];

  return {
    nome: form.personalInformation.fullName,
    cpfCnpj: getRawDocument(form.document),
    vendaLoginCpf: getRawDocument(vendaLoginCpf),
    dddCelular: formattedCellphone.substring(0, 2),
    numCelular: formattedCellphone.substring(2),
    dtNascimento: formatBrDate(form.personalInformation.birthDate),
    cepPernoite: formattedZipcode,
    endereco: {
      cep: formattedZipcode,
      cidade: form.address.city,
      bairro: form.address.neighborhood,
      logradouro: form.address.street,
      uf: form.address.state,
      numero: form.address.number ?? 'S/N',
      complemento: form.address.complement ?? 'S/C',
    },
    zeroKm: false,
    ano: form.vehicle.modelYear.toString(),
    codigoFipe: fipeCode!,
    digitoFipe: fipeDigit!,
    estadoCivil: martialStatusId,
    placa: form.licensePlate,
    sexo: form.personalInformation.gender === 'male' ? 'M' : 'F',
    vencimentoApolice: form.policyExpiration
      ? parseDate(`01/${form.policyExpiration}`)
      : undefined,
    utilizacaoVeiculo: form.usageVehicle,
    guardaVeiculo: formatStorageVehicle,
  };
};
